import { render, staticRenderFns } from "./MinusIcon.vue?vue&type=template&id=7e3d3321&"
import script from "./MinusIcon.vue?vue&type=script&lang=ts&"
export * from "./MinusIcon.vue?vue&type=script&lang=ts&"
import style0 from "./MinusIcon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports